import { HFModel } from '../types/content';

// Embedded fallback for the Hugging Face live layer (top downloads, captured at compilation).
export const HF_SNAPSHOT_AS_OF = '2026-10-05 (embedded snapshot)';

export const hfSnapshot: HFModel[] = [
  { id: 'sentence-transformers/all-MiniLM-L6-v2', downloads: 98_400_000, likes: 3900, pipeline_tag: 'sentence-similarity' },
  { id: 'google-bert/bert-base-uncased', downloads: 61_200_000, likes: 2300, pipeline_tag: 'fill-mask' },
  { id: 'openai/clip-vit-large-patch14', downloads: 24_800_000, likes: 1800, pipeline_tag: 'zero-shot-image-classification' },
  { id: 'FacebookAI/roberta-base', downloads: 18_900_000, likes: 520, pipeline_tag: 'fill-mask' },
  { id: 'sentence-transformers/all-mpnet-base-v2', downloads: 17_600_000, likes: 1100, pipeline_tag: 'sentence-similarity' },
  { id: 'Qwen/Qwen2.5-7B-Instruct', downloads: 14_100_000, likes: 780, pipeline_tag: 'text-generation' },
  { id: 'openai/whisper-large-v3', downloads: 9_800_000, likes: 4800, pipeline_tag: 'automatic-speech-recognition' },
  { id: 'BAAI/bge-m3', downloads: 8_700_000, likes: 2100, pipeline_tag: 'sentence-similarity' },
  { id: 'meta-llama/Llama-3.1-8B-Instruct', downloads: 7_400_000, likes: 4500, pipeline_tag: 'text-generation' },
  { id: 'openai/gpt-oss-20b', downloads: 6_900_000, likes: 3700, pipeline_tag: 'text-generation' },
  { id: 'deepseek-ai/DeepSeek-R1', downloads: 3_200_000, likes: 12_600, pipeline_tag: 'text-generation' },
  { id: 'google/gemma-3-27b-it', downloads: 2_100_000, likes: 1500, pipeline_tag: 'image-text-to-text' },
];
